<div *ngIf='sessionData' class='UpdatePersonalInfo'>
  <div
    class='UpdatePersonalInfo-header d-flex flex-row justify-content-between'>
    <h4 class='title__page'>My Profile</h4>
    <app-button
      [style]="'outline'"
      color='blue'
      route='/messages'
      size='small'
      text='Back to Inbox'></app-button>
  </div>
  <div *ngIf='formReady' class='UpdatePersonalInfo-form'>
    <form [formGroup]='formGroup'>
      <div class='row UpdatePersonalInfo-form-row'>
        <div class='col col-12 col-md-6'>
          <div class='UpdatePersonalInfo-form-label'>
            <p class='mb-0'>First Name</p>
          </div>
          <app-text-field
            formControlName='first_name'
            placeholder='First name'></app-text-field>
        </div>
        <div class='col col-12 col-md-6'>
          <div class='UpdatePersonalInfo-form-label'>
            <p class='mb-0'>Last Name</p>
          </div>
          <app-text-field
            formControlName='last_name'
            placeholder='Last name'></app-text-field>
        </div>
      </div>
      <div class='row UpdatePersonalInfo-form-row'>
        <div class='col col-12 col-md-6'>
          <div class='UpdatePersonalInfo-form-label'>
            <p class='mb-0'>Company Name</p>
          </div>
          <app-text-field
            formControlName='company'
            placeholder='Company'></app-text-field>
        </div>
        <div class='col col-12 col-md-6'>
          <div class='UpdatePersonalInfo-form-label'>
            <p class='mb-0'>Index auto refresh time</p>
          </div>
          <app-select
            [defaultValue]='refreshTimeValue'
            [items]='refreshTime'
            [label]="'Select refresh time'"
            formControlName='inbox_refresh_time'></app-select>
        </div>
      </div>

      <div class='row UpdatePersonalInfo-form-row'>
        <div class='col col-12 col-md-6'>
          <div class='UpdatePersonalInfo-form-label'>
            <p class='mb-0'>Phone number on record with card issuer:</p>
          </div>
          <app-text-field
            formControlName='phone_number'
            placeholder='Phone Number'></app-text-field>
          <div *ngIf='(phone_number.dirty || phone_number.touched) && phone_number.errors'
               class='alert alert-danger'>
            <p *ngIf='phone_number.errors?.pattern' class='mb-0'>Invalid phone number format. e.g. (555) 123-4567 for US
              or +12505550199 for Canada</p>
            <p *ngIf='phone_number.errors?.required' class='mb-0'>The phone number field is required</p>
          </div>
        </div>
      </div>
      <div *ngIf='isFranchisee' class='row UpdatePersonalInfo-form-row'>
        <div class='col col-12 col-md-6'>
          <div class='UpdatePersonalInfo-form-label'>
            <p class='mb-0'>Entity Type:</p>
          </div>
          <app-select
            [defaultValue]='entity_type?.value'
            [items]='franchiseeEntityTypes'
            formControlName='entity_type'
            label='Entity Type'></app-select>
          <div *ngIf='(entity_type.dirty || entity_type.touched) && entity_type.errors'
               class='alert alert-danger'>
            <p *ngIf='entity_type.errors?.required' class='mb-0'>Entity Type is required</p>
          </div>
        </div>
        <div class='col col-12 col-md-6'>
          <div class='UpdatePersonalInfo-form-label'>
            <p class='mb-0'>Signer Title:</p>
          </div>
          <app-text-field
            formControlName='signer_title'
            placeholder='Signer Title'></app-text-field>
          <div *ngIf='(signer_title.dirty || signer_title.touched) && signer_title.errors'
               class='alert alert-danger'>
            <p *ngIf='signer_title.errors?.required' class='mb-0'>Signer Title is required</p>
          </div>
        </div>
      </div>
      <div class='row UpdatePersonalInfo-form-row'>
        <div class='col col-12 col-md-6'>
          <div class='UpdatePersonalInfo-form-label'>
            <p class='mb-0'>Address 1:</p>
          </div>
          <app-text-field
            formControlName='address1'
            placeholder='Address 1'></app-text-field>
          <div *ngIf='isFranchisee && (address1.dirty || address1.touched) && address1.errors'
               class='alert alert-danger'>
            <p *ngIf='address1.errors?.required' class='mb-0'>Address 1 is required</p>
          </div>
        </div>
        <div class='col col-12 col-md-6'>
          <div class='UpdatePersonalInfo-form-label'>
            <p class='mb-0'>Address 2:</p>
          </div>
          <app-text-field
            formControlName='address2'
            placeholder='Address 2'></app-text-field>
        </div>
      </div>
      <div class='row UpdatePersonalInfo-form-row'>
        <div class='col col-12 col-md-6'>
          <div class='UpdatePersonalInfo-form-label'>
            <p class='mb-0'>City:</p>
          </div>
          <app-text-field
            formControlName='city'
            placeholder='City'></app-text-field>
        </div>
        <div class='col col-12 col-md-6'>
          <div class='UpdatePersonalInfo-form-label'>
            <p class='mb-0'>State:</p>
          </div>
          <app-select
            [items]='states'
            formControlName='state'
            label='State'></app-select>
        </div>
      </div>
      <div class='row UpdatePersonalInfo-form-row'>
        <div class='col col-12 col-md-6'>
          <div class='UpdatePersonalInfo-form-label'>
            <p class='mb-0'>Zip code:</p>
          </div>
          <app-text-field
            formControlName='zip'
            placeholder='Zip code'></app-text-field>
        </div>
        <div class='col col-12 col-md-6'>
          <div class='UpdatePersonalInfo-form-label'>
            <p class='mb-0'>Country:</p>
          </div>
          <app-select
            (selection)='onCountrySelect($event)'
            [defaultValue]='currentCountry'
            [items]='countries'
            formControlName='country'
            label='Country'></app-select>
        </div>
      </div>
      <div class='row UpdatePersonalInfo-form-button'>
        <div class='col col-12'>
          <app-button
            [Click]='continueButtonProperties.onClick'
            [color]='continueButtonProperties.color'
            [size]='continueButtonProperties.size'
            [style]='continueButtonProperties.style'
            [text]='continueButtonProperties.text'
            [disabled]="continueButtonProperties.observeApi"
            class='UpdatePersonalInfo-form-button'></app-button>
        </div>
      </div>
    </form>
  </div>
</div>
